import { useContext } from 'react';
import { TabContext } from '@/app/providers/TabProvider';
import type { TabContextValue } from '@/types';

export function useTabs(): TabContextValue {
  const context = useContext(TabContext);
  if (!context) {
    throw new Error('useTabs must be used within a TabProvider');
  }
  return context;
}
